const VARIANT_SELECT_EVENT = 'shopify:product:select';

if (!window.onnutoVariantDetailsBound) {
  window.onnutoVariantDetailsBound = true;

  document.addEventListener(VARIANT_SELECT_EVENT, (event) => {
    if (!event.promise || !(event.target instanceof Element)) return;

    const productRoot = event.target.closest('product-information, featured-product-information');

    event.promise
      .then(({ detail }) => {
        const incoming = detail?.html?.querySelector('[data-onnuto-variant-specs]');
        const currentRoot = productRoot?.isConnected ? productRoot : document;
        const current = currentRoot.querySelector('[data-onnuto-variant-specs]');

        if (!incoming || !current) return;
        current.innerHTML = incoming.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn('[onnuto-product-details] Variant update failed:', error);
        }
      });
  });
}
